import { Pipe, PipeTransform } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ExpressionEngineService } from './expression.service';

@Pipe({ name: 'aggregate', standalone: true, pure: true })
export class AggregatePipe implements PipeTransform {
	constructor(private expr: ExpressionEngineService) {}

	// data is the root object/array, expression is your JSONata string
	transform<T = any, R = number | string>(data: T, expression: string): Observable<R> {
		return from(this.expr.evaluate<T>(expression, data)).pipe(
			// keep UI stable if something is missing
			catchError(() => of(0 as unknown as R)),
		);
	}
}
